import React, { useEffect, useState } from 'react';
import { ReduxState, AppVersion } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import './HAS.style.scss';
import { Button, Drawer } from '@material-ui/core';
import { API, RoutePath } from 'data';
import { NavLink } from 'react-router-dom';
import { Modal, Spinner } from 'react-bootstrap';
import { offlineQuestionerSubmit } from 'ucheck/ucheck.scripts';
import { appLogout, deleteRegisterCode } from 'ucheck/ucheck.scripts';
import { toast } from 'react-toastify';
import { getPublishesOfflineAnswersCount } from 'scripts/db';
import { post } from 'scripts/api';

const HeaderAndSidebar: React.FC<ConnectedProps<typeof connector> & { onRefresh: () => Promise<boolean> }> = function (
    props: ConnectedProps<typeof connector> & { onRefresh: () => Promise<boolean> },
) {
    const [drawerState, setDrawerState] = useState<boolean>(false);
    const LANG = props.lang.components.HAS;
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [link, setLink] = useState<string>();

    function logout() {
        setLoading(true);
        getPublishesOfflineAnswersCount().then((offlineCount) => {
            if (offlineCount)
                offlineQuestionerSubmit().then((res) => {
                    if (res) {
                        deleteRegisterCode().then((resRegister) => {
                            // if (resRegister)
                            appLogout(props.dispatch);
                            // else toast.error(LANG.noInternetErr);
                            setLoading(false);
                        });
                    } else {
                        toast.error(LANG.noInternetErr);
                        setLoading(false);
                    }
                });
            else
                deleteRegisterCode().then((resRegister) => {
                    // if (resRegister)
                    appLogout(props.dispatch);
                    // else toast.error(LANG.noInternetErr);
                    setLoading(false);
                });
        });
    }

    function onRefreshHandler() {
        if (refreshing) return;
        setRefreshing(true);
        props.onRefresh().then((res) => {
            setRefreshing(false);
        });
    }

    function onTestHandler() {
        navigator.geolocation.getCurrentPosition(
            function (position) {
                console.log(position);
            },
            function (err) {
                console.log('user canceled', err);
            },
            { timeout: 15000 },
        );
    }

    useEffect(() => {
        post<AppVersion[]>(API.version(0), {}).then((res) => {
            const lastVersionID = res.data
                .map((i) => i.id)
                .reduce(function (a, b) {
                    return Math.max(a, b);
                }, 0);
            const lastVersion = res.data.findIndex((i) => i.id === lastVersionID);
            if (lastVersion !== undefined && lastVersion > -1) setLink(res.data[lastVersion].link);
        });
    }, []);

    return (
        <>
            {loading ? (
                <div className="loading-header-container d-flex align-items-center justify-content-center">
                    <Spinner animation="border" />
                </div>
            ) : null}
            <Modal show={show} className={`ucheck-kiosk-modal`} size={'lg'} centered>
                <i onClick={() => setShow(false)} className="material-icons close-icon">
                    close
                </i>
                <div className="ucheck-modal-body">
                    <p>{LANG.logoutConfirm}</p>
                </div>
                <div className="ucheck-modal-footer">
                    <Button className="cancel-button" disabled={loading} onClick={logout}>
                        {LANG.logout}
                    </Button>
                    <Button disabled={loading} className="cancel-button" onClick={() => setShow(false)}>
                        {LANG.cancel}
                    </Button>
                </div>
            </Modal>
            <div className="ucheck-kiosk-HAS">
                <div className="header">
                    <i onClick={() => setDrawerState(true)} className="material-icons">
                        menu
                    </i>
                    <span />
                    <i onClick={onRefreshHandler} className={`material-icons-outlined ${refreshing ? 'rotate' : ''}`}>
                        {refreshing ? 'sync' : 'refresh'}
                    </i>
                    <NavLink to={RoutePath.dashboard.notification}>
                        <i className="material-icons-outlined notification-icon">notifications</i>
                    </NavLink>
                </div>

                <Drawer
                    className="ucheck-sidebar"
                    anchor="left"
                    open={drawerState}
                    onClose={() => setDrawerState(false)}
                >
                    <div className="context">
                        <div onClick={onTestHandler} className="top">
                            {props.userData?.avatar?.avatar ? (
                                <img src={props.userData.avatar.avatar} alt="profile" />
                            ) : (
                                <span className="material-icons">account_circle</span>
                            )}
                            <p>{props.userData?.full_name ? props.userData?.full_name : props.userData?.phone}</p>
                        </div>
                        <div className="links">
                            <NavLink activeClassName="active" className="item" to={RoutePath.dashboard.profile.index}>
                                <i className="material-icons">person</i>
                                <p>{LANG.profile}</p>
                            </NavLink>
                            <a className="item" target="_blank" rel="noreferrer" href="https://www.ucheck.me/help">
                                <i className="material-icons">school</i>
                                <p>{LANG.learn}</p>
                            </a>
                            <a
                                className="item"
                                target="_blank"
                                rel="noreferrer"
                                href={`https://uchk.ir/gHEHQx/?u=${props.userData?.email}`}
                            >
                                <i className="material-icons">help</i>
                                <p>{LANG.support}</p>
                            </a>
                            <a className="item" target="_blank" rel="noreferrer" href="http://ucheck.me/">
                                <i className="material-icons">info</i>
                                <p>{LANG.aboutUs}</p>
                            </a>
                            <NavLink
                                to="#"
                                activeClassName="active"
                                className="item"
                                onClick={() => {
                                    setDrawerState(false);
                                    setTimeout(() => {
                                        setShow(true);
                                    }, 700);
                                }}
                            >
                                <i className="material-icons">logout</i>
                                <p>{LANG.logout}</p>
                            </NavLink>
                            <span />
                            <div className="footer">
                                <p>{LANG.version} 1.0.6</p>
                                <span />
                                <a target="_blank" rel="noreferrer" href={'https://www.ucheck.me/application'}>
                                    {LANG.promote}
                                </a>
                            </div>
                        </div>
                    </div>
                </Drawer>
            </div>
        </>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    dir: state.direction,
    userData: state.userData,
    lang: state.lang,
});

const connector = connect(mapStateToProps);
export default connector(HeaderAndSidebar);
